<div class="version-info">
  <h2>Versies</h2>

  <p><strong>UI-versie:</strong> {{ uiVersion }}</p>

  <div *ngIf="apiVersion">
    <p><strong>API-versie:</strong> {{ apiVersion.version }}</p>
    <p><strong>Env:</strong> {{ envName }}</p>
  </div>
  <p *ngIf="!isInApk">
    <a [href]="apkUrl" download class="apk-link">
      <span class="material-icons">android </span>
      <span class="material-icons">download</span>
    </a>
  </p>
</div>
